/* eslint-disable import/prefer-default-export */
export const LEAVE_OPTION = 'leave';
